// extracted by mini-css-extract-plugin
export default {"heading":"threadTitle_heading__DlrjY"};